import(/* webpackMode: "eager" */ "/codebuild/output/src1604504694/src/apps/jumplab/src/app/error.tsx");
